import { createFileRoute } from '@tanstack/react-router'
import { PhoneNumberEditRoutePage } from '@/features/operations/phone-numbers/pages/phone-number-edit-route-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/dids/$id')({
  beforeLoad: requireRole(['admin']),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <PhoneNumberEditRoutePage didId={id} />
}
